import { render, staticRenderFns } from "./NewMessagePollEditor.vue?vue&type=template&id=173c0954&scoped=true"
import script from "./NewMessagePollEditor.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewMessagePollEditor.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./NewMessagePollEditor.vue?vue&type=style&index=0&id=173c0954&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173c0954",
  null
  
)

export default component.exports